<template>
  <div class="contact-wrap">
    <div class="contact-info">
      <div class="contact-item border">
        <account-avatar :account="imActiveContact" />
        <div class="contact-item-content">
          <div class="contact-item-content-name">
            <span>{{ nickName }}</span>
            <span role="img" tabindex="-1" :class="gender">
              <svg class="iconpark-icon"  width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">
                <use :href="'#' + gender"></use>
              </svg>
            </span>
          </div>
          <div class="contact-item-content-msg">
            <div class="contact-item-content-msg-body">IM账号：{{ imActiveContact.im_accid }}</div>
          </div>
        </div>
      </div>
      <div class="contact-item border gap1">
        <span class="item-label">个性签名</span>
        <span class="item-label-sign">{{ imSign }}</span>
      </div>
      <div class="contact-item-operate">
        <div class="contact-item-operate-icon">
          <span @click="createSession">
            <i class="ukfont youkai-chat-round"></i>
          </span>
          <span>发送消息</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AccountAvatar from '../../AccountAvatar.vue'
export default {
  name: 'ContactWrap',
  components: { AccountAvatar },
  props: {
    imActiveContact: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      imSessions: state => state.imSessions,
      imSessionMap: state => state.imSessionMap
    }),
    nickName () {
      return this.imActiveContact.im_name ? this.imActiveContact.im_name : ''
    },
    imSign () {
      return this.imActiveContact.im_sign ? this.imActiveContact.im_sign : '这个人很懒，什么也没留下'
    },
    gender () {
      if (this.imActiveContact.im_gender === 1) return 'male'
      if (this.imActiveContact.im_gender === 2) return 'female'

      return ''
    }
  },
  watch: {
  },
  methods: {
    ...mapActions(['addSession', 'loadMoreMsgOfSession', 'fetchUserInfo']),
    createSession () {
      this.addSession({ account: this.imActiveContact.im_accid, scene: 'p2p' })
      this.fetchUserInfo(this.imActiveContact.im_accid)
      // this.loadMoreMsgOfSession({ scene: 'p2p', to: this.imActiveContact.im_accid, limit: 10, messageListScrollTot: 'bottom' })
    }
  }
}
</script>

<style lang="stylus" scoped>
.contact-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contact-info {
  min-width: 300px;
}
.contact-item {
  display: flex;
  font-size: 14px;
  color: #333;
  padding: 12px;
  position: relative;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  align-items: center;
  gap: 5px;
}
.m-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.m-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnim";
  position: relative;
  display: inline-block;
}
.m-avatar {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  vertical-align: middle;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  border-radius: 8px;
}
.m-avatar-icon {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  vertical-align: middle;
  background-color: rgb(190, 101, 217);
}
.m-avatar-string {
  line-height: 36px;
  transform: scale(0.777778) translateX(-50%);
}
.contact-item-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 6px 0 10px;
  flex: 1;
  min-width: 0;
  line-height: normal;
}
.contact-item-content-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contact-item-content-msg {
  font-size: 12px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.contact-item-content-msg-body {
  font-size: 12px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.male {
  color: #4d84fe;
}
.female {
  color: #fb7373;
}
.item-label {
  font-size: 13px;
  color: #999;
}
.item-label-sign {
  font-size: 13px;
}
.gap1 {
  gap: 10px;
}
.border {
  border-bottom: 1px solid #ded9d9;
}
.contact-item-operate {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 12px 12px 12px;
}
.contact-item-operate-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  color: #687aa0;
}
.contact-item-operate-icon i {
  font-size: 24px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/contacts/ContactWrap.vue